import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import api from '@/axios';
import { GET_DOCUMENT_TYPES_KEY } from '@/keys';
import type { DocumentType } from '@/types/core/document-type';

export const getDocumentTypes = async (): Promise<DocumentType[]> => {
  const response = await api.get<DocumentType[]>('/document-types');
  return response.data;
};

export const useGetDocumentTypes = (): UseQueryResult<DocumentType[], Error> =>
  useQuery({
    queryKey: GET_DOCUMENT_TYPES_KEY,
    queryFn: getDocumentTypes,
  });
